import Vue from 'vue'
import Router from 'vue-router'
const home = resolve => require(['./views/Home'],resolve)
//公共部分
const layout = resolve => require(['./components/layout'],resolve)
const login = resolve => require(['./views/Login'],resolve)
//經文
const lectionCla = resolve => require(['./views/lection/lectionCla'],resolve)
const lectionList = resolve => require(['./views/lection/LectionList'],resolve)
const addLection = resolve => require(['./views/lection/addLection'],resolve)
//叢書
const wordCla = resolve => require(['./views/word/wordCla'],resolve)
const wordList = resolve => require(['./views/word/wordList'],resolve)
const addWord = resolve => require(['./views/word/addWord'],resolve)
//音樂
const musicList = resolve => require(['./views/music/musicList'],resolve)
//賬號
const userList = resolve => require(['./views/user/userManager'],resolve)
const vipManager = resolve => require(['./views/user/vipManager'],resolve)
//公告
const noticeManager = resolve => require(['./views/notice/noticeManager'],resolve)
//廣告
const bannerManager = resolve => require(['./views/banner/bannerManager'],resolve)
const mobileBannerManager = resolve => require(['./views/banner/mobileBannerManager'],resolve)
const openOrClose = resolve => require(['./views/banner/openOrClose'],resolve)
//友情鏈接
const linkManager = resolve => require(['./views/link/linkManager'],resolve)
//商品管理
const categoryManager = resolve => require(['./views/proManager/categoryManager'],resolve)
const proEdit = resolve => require(['./views/proManager/proEdit'],resolve)
const proList = resolve => require(['./views/proManager/proList'],resolve)
const proDownList = resolve => require(['./views/proManager/proDownList'],resolve)
const recommendPro = resolve => require(['./views/proManager/recommendPro'],resolve)
const feightManager = resolve => require(['./views/proManager/feightManager'],resolve)
//訂單管理
const orderList = resolve => require(['./views/order/orderList'],resolve)
const noPayList = resolve => require(['./views/order/noPayList'],resolve)
const cancelOrder = resolve => require(['./views/order/cancelOrder'],resolve)
const sendOrder = resolve => require(['./views/order/sendOrder'],resolve)

Vue.use(Router)
export default new Router({
    base: '/manager',
  routes: [
      {
          path:'/login',
          component:login,
          name:'login'
      },
      {
          path:'*',
          component:layout,
      },
      {
          path: '/',
          component: layout,
          children: [
              {
                  path: '',
                  component: home
              }
              ,{
                  path:'/home',
                  name:'home',
                  component:home
              }
              ,{
                  path:'/lectionCla',
                  name:'lectionCla',
                  component:lectionCla
              }
              ,{
                  path:'/lectionList',
                  name:'lectionList',
                  component:lectionList
              }
              ,{
                  path:'/addLection',
                  name:'addLection',
                  component:addLection
              }
              ,{
                  path:'/mobileBannerManager',
                  name:'mobileBannerManager',
                  component:mobileBannerManager
              }
              ,{
                  path:'/categoryManager',
                  name:'categoryManager',
                  component:categoryManager
              }
              ,{
                  path:'/proEdit',
                  name:'proEdit',
                  component:proEdit
              }
              ,{
                  path:'/proList',
                  name:'proList',
                  component:proList
              }
              ,{
                  path:'/feightManager',
                  name:'feightManager',
                  component:feightManager
              }
              ,{
                  path:'/proDownList',
                  name:'proDownList',
                  component:proDownList
              }
              ,{
                  path:'/recommendPro',
                  name:'recommendPro',
                  component:recommendPro
              }
              ,{
                  path:'/orderList',
                  name:'orderList',
                  component:orderList
              }
              ,{
                  path:'/cancelOrder',
                  name:'cancelOrder',
                  component:cancelOrder
              }
              ,{
                  path:'/noPayList',
                  name:'noPayList',
                  component:noPayList
              }
              ,{
                  path:'/sendOrder',
                  name:'sendOrder',
                  component:sendOrder
              }
              ,{
                  path:'/wordCla',
                  name:'wordCla',
                  component:wordCla
              }
              ,{
                  path:'/linkManager',
                  name:'linkManager',
                  component:linkManager
              }
              ,{
                  path:'/wordList',
                  name:'wordList',
                  component:wordList
              }
              ,{
                  path:'/addWord',
                  name:'addWord',
                  component:addWord
              }
              ,{
                  path:'/bannerManager',
                  name:'bannerManager',
                  component:bannerManager
              }
              ,{
                  path:'/openOrClose',
                  name:'openOrClose',
                  component:openOrClose
              }
              ,{
                  path:'/musicList',
                  name:'musicList',
                  component:musicList
              }
              ,{
                  path:'/userList',
                  name:'userList',
                  component:userList
              }
              ,{
                  path:'/vipManager',
                  name:'vipManager',
                  component:vipManager
              }
              ,{
                  path:'/noticeManager',
                  name:'noticeManager',
                  component:noticeManager
              }
          ]
      }

  ]
})
